import React from 'react'
import ReactDOM from 'react-dom'
import './assets/scss/global.scss'
import i18n from './i18n'
import { I18nextProvider } from 'react-i18next'
import App from './App'
import { Provider } from 'react-redux'
import { LastLocationProvider } from 'react-router-last-location'
import store, { history, persistor } from './Store'
import { Router } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import TagManager from 'react-gtm-module'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import { theme } from './theme'
import * as Sentry from '@sentry/browser'
import { BackgroundChecks } from './components'
import { SubdomainSanitizer } from './SubdomainSanitizer'

const GlobalStyle = createGlobalStyle`
  html, body {
    font-family: ${({ theme }) => `${theme.fontStack};`}
  }
`

// Sentry environments are lowercase and short across Rentio, matching what the APIs send: api-next's
// RENTIO_ENVIRONMENT and legacy's NODE_ENV are both `dev` | `stag` | `demo` | `prod`. REACT_APP_ENV
// spells two of them differently and picks the API base URLs in networkService, so it keeps its
// values and only what Sentry sees is normalized.
const SENTRY_ENVIRONMENTS = { dev: 'dev', demo: 'demo', staging: 'stag', production: 'prod' }

// NODE_ENV is 'development' for `yarn start` and 'production' for a build, whatever REACT_APP_ENV
// says. Without that check, `yarn start:production` - which sources .env.production, the only file
// carrying a DSN - would report from a developer machine tagged as production.
if (process.env.NODE_ENV !== 'development' && process.env.REACT_APP_SENTRY) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY,
    environment: SENTRY_ENVIRONMENTS[process.env.REACT_APP_ENV] || process.env.REACT_APP_ENV,
    // Stamped by the deploy pipeline as the commit hash, matching the release it registers in
    // Sentry. Empty in a local build, which Sentry reads as "no release".
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    integrations: [
      new Sentry.Integrations.GlobalHandlers({
        onerror: true,
        onunhandledrejection: false,
      }),
    ],
  })
}

if (process.env.REACT_APP_GTM) {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM,
  }
  TagManager.initialize(tagManagerArgs)
}

ReactDOM.render(
  <SubdomainSanitizer>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <PersistGate loading={null} persistor={persistor}>
          <I18nextProvider i18n={i18n}>
            <React.Fragment>
              <GlobalStyle />
              <Router history={history}>
                <LastLocationProvider>
                  <App />
                  <BackgroundChecks />
                </LastLocationProvider>
              </Router>
            </React.Fragment>
          </I18nextProvider>
        </PersistGate>
      </ThemeProvider>
    </Provider>
  </SubdomainSanitizer>,
  document.getElementById('root'),
)



// WEBPACK FOOTER //
// ./src/index.js